export enum SupportMutationType {
  SET_LOADING = 'SET_LOADING',
  SET_FAQ_ITEMS = 'SET_FAQ_ITEMS',
  SET_FAQ_PAGES = 'SET_FAQ_PAGES',
  SET_KNOWLEDGE_BASE_ITEMS = 'SET_KNOWLEDGE_BASE_ITEMS',
  SET_SEARCH = 'SET_SEARCH'
}
